// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1Sdac","form":"styles_form__1Ja5o"};